export default __webpack_public_path__ + "static/media/pool-gourmet-area.1f1add1b.png";